/**
 * @generated SignedSource<<14ddbe162f0386fedc49c571117af8d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type RepositoryPickerTopRepositories$data = {
  readonly topRepositories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly databaseId: number | null | undefined;
        readonly hasAnyTemplates: boolean;
        readonly hasIssuesEnabled: boolean;
        readonly id: string;
        readonly isArchived: boolean;
        readonly isBlankIssuesEnabled: boolean;
        readonly isInOrganization: boolean;
        readonly isLocked: boolean;
        readonly isOwnerEnterpriseManaged: boolean | null | undefined;
        readonly isPrivate: boolean;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly avatarUrl: string;
          readonly databaseId: number | null | undefined;
          readonly issueTypesEnabled: boolean;
          readonly login: string;
        };
        readonly shortDescriptionHTML: string;
        readonly slashCommandsEnabled: boolean;
        readonly viewerCanCreateIssues: boolean;
        readonly viewerCanPush: boolean;
        readonly viewerInteractionLimitReasonHTML: string | null | undefined;
        readonly viewerIssueCreationPermissions: {
          readonly assignable: boolean;
          readonly canSetIssueFields: boolean;
          readonly labelable: boolean;
          readonly milestoneable: boolean;
          readonly triageable: boolean;
          readonly typeable: boolean;
        };
        readonly visibility: RepositoryVisibility;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly " $fragmentType": "RepositoryPickerTopRepositories";
};
export type RepositoryPickerTopRepositories$key = {
  readonly " $data"?: RepositoryPickerTopRepositories$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPickerTopRepositories">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RepositoryPickerTopRepositories"
};

(node as any).hash = "a0a430034e412c05a88d5d817d7b3911";

export default node;
